import { Typography } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';

export function Header({ isMobile }: { isMobile?: boolean }) {
  const { resultHeading } = useSettings();

  if (!resultHeading) {
    return null;
  }

  return (
    <Typography
      lineHeight="40px"
      textStyle={{ fontSize: isMobile ? 24 : 32, fontWeight: 'bold' }}
    >
      {resultHeading}
    </Typography>
  );
}
